<template>
  <VRow
    justify="center"
    class="mt-6"
  >
    <VCol
      cols="12"
      md="10"
    >
      <VCard>
        <VCardTitle>Recent Activities</VCardTitle>
        <VCardText>
          <v-table>
            <thead>
              <tr>
                <th>Environment</th>
                <th>Run ID</th>
                <th>Status</th>
                <th>Last Updated</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="activity in activities"
                :key="activity.id"
              >
                <td class="text-capitalize">
                  {{ activity.environment }}
                </td>
                <td>
                  <a
                    :href="activity.htmlUrl"
                    target="_blank"
                    rel="noopener"
                  >
                    {{ activity.runNumber }}
                  </a>
                </td>
                <td>
                  <span
                    :class="{
                      'text-success': activity.status === 'completed',
                      'text-warning': activity.status === 'in_progress' || activity.status === 'queued',
                      'text-error': activity.status === 'failed',
                    }"
                  >
                    {{ activity.status }}
                  </span>
                </td>
                <td>{{ formatDate(activity.updatedAt) }}</td>
                <td>
                  <v-btn
                    variant="text"
                    @click="$emit('view-result', activity.runNumber, activity.environment)"
                    >See Result
                  </v-btn>
                </td>
              </tr>
            </tbody>
          </v-table>
        </VCardText>
      </VCard>
    </VCol>
  </VRow>
</template>

<script setup lang="ts">
// Props
interface Activity {
  id: string
  environment: string
  htmlUrl: string
  runNumber: string
  status: string
  updatedAt: string
}

defineProps({
  activities: {
    type: Array as () => Activity[],
    required: true,
  },
})

// Emits
defineEmits(['view-result'])

// Helper function to format date
const formatDate = (dateString: string) => {
  const options: Intl.DateTimeFormatOptions = {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit',
  }
  return new Date(dateString).toLocaleDateString(undefined, options)
}
</script>

<style scoped></style>
